/* eslint-disable no-unused-vars */
import './About.css'

function About() {
    return (
        <div className="about-page">
            <div className="about-content">
                <h1>About Marque Index</h1>

                <div className="about-section">
                    <h2>What is this?</h2>
                    <p>
                        Marque Index is a menswear brand discovery platform. We try to aggregate 
                        a variety of brands and surface ones that match your aesthetic.
                    </p>
                </div>

                <div className="about-section">
                    <h2>How it works</h2>
                    <p>
                        Every brand in our index is scored across multiple dimensions
                        When you save or discard brands, we use that information to find brands with
                        similar aesthetic DNA to recommend
                    </p>
                </div>
                <div className="about-section">
                    <h2>Contact</h2>
                    <p>
                        Have a brand suggestion or feedback? We'd love to hear from you.
                    </p>
                    <p>
                        <a href="mailto:hello@marqueindex.com">hello@marqueindex.com</a>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default About
